<template>
  <div>
    <template v-if="display === 'invitation' && showForm">
      <header-bar>
        スプリット
      </header-bar>
      <div class="page-block">
        <div class="page-block__inner">
          <div class="invitation-container">
            <div class="invitation-container__desc">
              メールに記載のスプリットコードを入力してください
            </div>
            <div class="form-group b0">
              <div class="form-item">
                <input
                  v-model="invitationCode"
                  class="form-control"
                  type="text">
              </div>
            </div>
            <p :class="errorMessage !== '' ? 'error-text' : ''">{{ errorMessage }}</p>
            <div class="c-btn-wrap">
              <button
                class="c-btn"
                name="submit"
                type="button"
                :disabled="!invitationCode"
                @click.prevent="verifyCode">
                送信
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template>
      <account-information
        v-if="check && display === 'user-data-input'"
        :company-id="companyId"
        @showSection="show('confirm-user-data')" />
      <confirm-account-information
        v-if="check && display === 'confirm-user-data'"
        :company-id="companyId"
        @show="show" />
    </template>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'
import AccountInformation from '../User/AccountInformation'
import ConfirmAccountInformation from '../User/ConfirmAccountInformation'
import account from '../../mixins/account'

export default {
  name: 'InvitationCode',
  components: {
    HeaderBar,
    AccountInformation,
    ConfirmAccountInformation,
  },
  mixins: [
    account,
  ],
  data() {
    return {
      invitationCode: '',
      userEmail: '',
      errorMessage: '',
      showForm: false,
      check: false,
      display: 'invitation',
      companyId: '',
      isCompleteAccount: false,
    }
  },
  async mounted() {
    this.userEmail = this.$store.state.auth.email
    this.companyId = (this.$store
      && this.$store.state
      && this.$store.state.auth
      && this.$store.state.auth.company)
      ? this.$store.state.auth.company.id
      : ''
    this.userData = await this.getUser('split-invitation')
    this.isCompleteAccount = this.checkIfUserDataAvailable(this.userData)
    await this.verifyUrl(this.$route.query.invitation_code)
  },
  methods: {
    async verifyCode() {
      if (this.invitationCode) {
        try {
          const response = await window.axios.post('/api/client/revenueShare/invitationCode/validate', {
            invitationCode: this.invitationCode,
            email: this.userEmail,
          })
          const session = JSON.parse(window.sessionStorage.getItem('split')) || {}
          session.productId = response.data.data[0].product_id
          session.revenueShareId = response.data.data[0].id
          window.sessionStorage.setItem('split', JSON.stringify(session))
          if (response.status === 200) {
            this.check = true
            if (!this.isCompleteAccount) {
              this.display = 'user-data-input'
            } else {
              this.display = 'confirm-user-data'
            }
          } else if (response.status === 403) {
            this.errorMessage = response.data.message
          }
        } catch (error) {
          if (error.response.status === 403) {
            this.errorMessage = error.response.data.message
            return
          }
          this.errorMessage = 'スプリットコードに誤りがあります。'
        }
      }
    },
    async verifyUrl(code) {
      if (code) {
        try {
          const response = await window.axios.post('/api/client/revenueShare/invitationUrl/validate', {
            code: encodeURIComponent(code),
            email: this.userEmail,
          })
          if (response.status === 200) {
            this.showForm = true
          } else if (response.status === 203) {
            const split = { revenueShareId: '', productId: '' }
            split.revenueShareId = this.$route.query.rsId
            split.productId = this.$route.query.productId
            sessionStorage.setItem('split', JSON.stringify(split))
            this.check = true
            if (!this.isCompleteAccount) {
              this.display = 'user-data-input'
            } else {
              this.display = 'confirm-user-data'
            }
          }
        } catch (error) {
          this.$router.push({ name: 'index' })
        }
      } else {
        this.$router.push({ name: 'index' })
      }
    },
    // handle which content should be displayed in screen
    show(section = '') {
      this.scrollToTop()
      this.display = section
    },
  },
}
</script>

<style scoped>
.error-text {
  color: #ff0000;
  display: block;
}
.b0{
  border-bottom: none;
}
@media screen and (max-width: 895px) {
  .c-btn-wrap {
    padding: 4vw;
  }
}
@media screen and (min-width: 896px) {
  .form-group {
    padding-bottom: 0;
  }
}
</style>
